import { useState } from "react";
import RagnaWindow from "../ReactComponents/RagnaWindow";
import { Progress, Alert, Row, Col } from 'reactstrap';
import axios from 'axios';
import { ajax_api, api_base } from "../../Globals";


const FilesRelink = props => {
    const STATE = {
        INIT: 0,
        FETCHING_IDS: 1,
        READY: 2,
        ONGOING: 3,
        FINISHED: 4
    }

    const [currentState, setCurrentState] = useState(STATE.INIT);
    const [fileIds, setFileIds] = useState([]);
    const [filesProcessed, setFilesProcessed] = useState([]);

    const getFileIds = _ => {
        axios.get(`${ajax_api}sync/get-file-ids`).then(d => {
            console.log(d)
            setFileIds(d.data);
            setCurrentState(STATE.READY)
        });
    }

    const relinkFile = i => {
        if (fileIds.length > i) {
            var successful = false;
            axios.get(`${ajax_api}sync/set-file-relink`, {
                params: {
                    id: fileIds[i]
                }
            }).then(d => {
                successful = true;
            }).finally(_ => {
                setFilesProcessed(f => [...f, { id: fileIds[i], success: successful }])
                relinkFile(i + 1)
            });
        } else {
            //finished!
            if (filesProcessed.filter(f => f.success == false).length > 0) {
                console.log("START!!!!!!!!! LIST OF FAILED IDS!");
                console.log(filesProcessed.filter(f => f.success == false));
                console.log("END!!!!!!!!!!! LIST OF FAILED IDS!");
            }
            setCurrentState(STATE.FINISHED)
        }
    }

    const getCurrentButtons = state => {
        switch (state) {
            case STATE.INIT:
                return <>
                    <button onClick={_ => {
                        setCurrentState(STATE.FETCHING_IDS)
                        getFileIds();
                    }
                    } className="ro-button"><span>Start</span></button>
                </>
            case STATE.READY:
                if (fileIds.length == 0) {
                    return <></>
                }
                return <>
                    <button onClick={_ => {
                        relinkFile(0);
                        setCurrentState(STATE.ONGOING)
                    }
                    } className="ro-button"><span>Start Linking</span></button>
                </>
            default:
                return <></>
        }
    }

    const getCurrentBody = state => {
        switch (state) {
            case STATE.INIT:
                return <>Press start to initialize data</>
            case STATE.FETCHING_IDS:
                return <>
                    Fetching document ids..
                </>
            case STATE.READY:
                if (fileIds.length == 0) {
                    return <>NO DOCUMENT FILES FOUND!</>
                }
                return <>
                    Press Start Linking to start the relinking process | Total {fileIds.length} files.
                </>
            case STATE.ONGOING:
                return <>
                    <Row>
                        <Col>
                            Progress:
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                            {filesProcessed.length} / {fileIds.length} ({Math.round((filesProcessed.length / fileIds.length * 100) * 100) / 100}%)
                        </Col>
                    </Row>
                    <Progress style={{ height: 8 }} value={filesProcessed.length / fileIds.length * 100}>

                    </Progress>
                </>
            case STATE.FINISHED:
                return <>
                    FINISHED! Successful relinks: {filesProcessed.filter(f => f.success).length} items out of {fileIds.length} !
                    {
                        filesProcessed.filter(f => f.success == false).length > 0 ?
                            <>
                                Check console for failed relink ids..
                            </> : ""
                    }
                </>
            default:
                return
        }
    }

    return <RagnaWindow
        footer={getCurrentButtons(currentState)}>
        {getCurrentBody(currentState)}
    </RagnaWindow>
}

export default FilesRelink;